import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { closeScheduleAppointmentDialog } from '../../store/actions/appointments.actions';

@Injectable({
  providedIn: 'root',
})
export class ScheduleAppointmentHelperService {
  private store = inject(Store);
  private _currentStep: 1 | 2 | 3 | 4 | 5 = 1;

  get currentStep(): 1 | 2 | 3 | 4 | 5 {
    return this._currentStep;
  }

  nextStep(isVirtualVisitType?: boolean) {
    this._currentStep += this._currentStep === 2 && isVirtualVisitType ? 2 : 1;
  }

  previousStep(isVirtualVisitType?: boolean) {
    this._currentStep -= this._currentStep === 4 && isVirtualVisitType ? 2 : 1;
  }

  resetSteps() {
    this._currentStep = 1;
  }

  closeDialog() {
    this.store.dispatch(closeScheduleAppointmentDialog());
  }
}
